import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Button, Input, Spinner } from "@material-tailwind/react";
import { update_Feedback_Sub_Category, add_Feedback_Sub_Category, get_FeedbackCategory } from '../../Controller/actions';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '../Switch/Switch';
import Select from 'react-select';
import { NewContext } from '../../Context/NewContext';

export const FeedbackSubCategoryModel = () => {
    const { isModalLoading, setFormData, openSubCategory, setopenSubCategory, setDeleteUpdateTag, deleteUpdateYes, handleSwitch, setIsModalLoading, handleClose, handleChange, formData, open, addEditDeleteTag } = useContext(NewContext);

    const [selectedValues, setSelectedValues] = useState("");
    const [apiData, setApiData] = useState([]);

    const getStickerTags = async () => {
        const getStickerData = await get_FeedbackCategory();
        const options = getStickerData.data.filter((item) => item.isActive == true).map((item) => ({
            value: item._id,
            label: item.name,
        }));
        setApiData(options);

        const selectedFromFormData = formData?.tag || [];
        // let newArray = []
        selectedFromFormData.filter((selectedItem) => {
            const newObject = {
                value: selectedItem,
                label: selectedItem
            }
            // newArray.push(newObject)
            setSelectedValues(newObject);
        });
    }

    useEffect(() => {
        getStickerTags()
    }, [formData?.name])

    const handleSelectChange = (newValue, actionMeta) => {
        setSelectedValues(newValue);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        let createUpdateSounds;
        setIsModalLoading(true);

        const getcategoryId = selectedValues?.value;
        const obj = {
            categoryId: getcategoryId,
            name: formData?.name ? formData?.name : "",
            isActive: formData?.isActive ? true : false,
        }

        if (addEditDeleteTag === `update`) {
            createUpdateSounds = await update_Feedback_Sub_Category(obj, formData?._id)
        } else {
            createUpdateSounds = await add_Feedback_Sub_Category(obj)
        }
        setIsModalLoading(false);
        if (createUpdateSounds) {
            const { message, status } = createUpdateSounds;
            if (status) {
                toast.success(message);
                setopenSubCategory(false);
                setDeleteUpdateTag(deleteUpdateYes);
                setSelectedValues("");
            } else {
                toast.error(message);
            };
        }
    }

    useEffect(() => {
        if (addEditDeleteTag === `add`) setFormData({ ...formData, isActive: true })
    }, [addEditDeleteTag]);
    return (
        <>
            <Dialog
                open={openSubCategory}
                onClose={() => setopenSubCategory(false)}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "425px",
                            borderRadius: "12px" // Set your width here
                        },
                    },
                }}
            >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit Sub Category` : `Add Sub Category`
                    }
                </DialogTitle>
                <DialogContent>
                    <div>
                        {
                            <form onSubmit={handleSubmit}>
                                <div className="grid grid-cols-6 lg:grid-cols-6 gap-5 add-edit-form">

                                    <div className="mt-2 col-span-6 sm:col-span-6">
                                        <label htmlFor="categories" className="block text-sm font-medium leading-6 text-gray-900 -z-10"><p>Category <sup className='text-red-600'>*</sup> :</p> </label>
                                        <div className="my-1.5 tag-multiselect">
                                            <Select
                                                options={apiData}
                                                onChange={handleSelectChange}
                                                value={selectedValues}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-span-6 sm:col-span-6">
                                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900"><p>Name <sup className='text-red-600'>*</sup> :</p> </label>
                                        <div className="mt-2">
                                            <Input id='name' placeholder='Enter name' name='name' onChange={handleChange} value={formData?.name} autoComplete='false' required />
                                        </div>
                                    </div>

                                    <div className="col-span-2 sm:col-span-2">
                                        <label htmlFor="isActive" className="block text-sm font-medium leading-6 text-gray-900">Active:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isActive' name='isActive' onChange={handleSwitch} checked={formData?.isActive} />
                                        </div>
                                    </div>
                                </div>
                                <div className='flex justify-end mt-5'>
                                    <Button
                                        onClick={() => setopenSubCategory(false)}
                                        className="mr-2.5 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                    >
                                        <span>Cancel</span>
                                    </Button>
                                    <Button
                                        disabled={isModalLoading}
                                        className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                        type='submit'
                                    >
                                        {isModalLoading && <Spinner className="h-4 w-4" />}
                                        <span className={isModalLoading ? 'ml-4' : ''}>{addEditDeleteTag === `add` ? `Add` : `Update`}</span>
                                    </Button>
                                </div>
                            </form>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default FeedbackSubCategoryModel
